import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, Button, TextField, Box, Typography, Grid, MenuItem, Avatar } from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import moment from "moment/moment";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import Select from "react-select";
import { useCreateNCRLogMutation } from "store/slices/apis/ncrLogApiSlice";
import CalenderSVG from "assets/logo/Calendar";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";

const ncrResponse = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
];

const rightLabelStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
};

const rightTextStyle = {
    "& .MuiInputBase-input": {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "100%",
        letterSpacing: "0.16px",
        color: "#0A0A0C",
        fontFamily: "Outfit, sans-serif",
    },
};

const labelTextStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
    mb: 1,
    mt: 1,
};

const AddNCRLog = (props) => {
    const { open, handleClose, ncrLogContact } = props;
    const { projectId } = useParams();
    const dispatch = useDispatch();

    const [createNCRLog, { isLoading }] = useCreateNCRLogMutation();

    const module = "NCRLog";

    const { data: ncrLogStatusRes } = useGetMasterDataQuery({ module: module, category: 'Status', ProjectId: projectId });
    const ncrLogStatusData = ncrLogStatusRes?.data || [];
    const ncrStatusOptions = (ncrLogStatusData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const { data: ncrLogNCRSORes } = useGetMasterDataQuery({ module: module, category: 'NCRSO', ProjectId: projectId });
    const ncrLogNCRSOData = ncrLogNCRSORes?.data || [];
    const ncrSoOptions = (ncrLogNCRSOData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const [formData, setFormData] = useState({
        dateOfIssuedLetter: "",
        letterNumber: "",
        numberOfObservationsRaised: null,
        letterReference: "",
        areaOrItemOfInspection: "",
        ncRorSO: "",
        asset: "",
        contractorName: "",
        personResponsible: "",
        // dueDate: "",
        observationSummary: "",
        remarksOrActionRequired: "",
        isResponseSharedWithAuthority: "",
        ncrStatus: "",
        dateOfClosure: "",
        ageingDays: null,
        tatInDays: null,
        dateOfResponse: "",
        grilResponse: "",
        numberOfObservationsAddressed: null,
        responseLetterReference: "",
        projectId: projectId,
    });

    const validationSchema = Yup.object({
        dateOfIssuedLetter: Yup.date().required("Date Issued field is required"),
        letterNumber: Yup.string().trim().required("Letter Number field is required"),
        numberOfObservationsRaised: Yup.number().required("Observations Raised field is required"),
        // letterReference: Yup.string().required("Letter Ref. field is required"),
        areaOrItemOfInspection: Yup.string().trim().required("Area/Item Of Inspection field is required"),
        ncRorSO: Yup.string().trim().required("NCR/SO field is required"),
        asset: Yup.string().trim().required("Asset field is required"),
        personResponsible: Yup.string().required("Person Responsible field is required"),
        // dueDate: Yup.date().required("Due Date field is required"),
        observationSummary: Yup.string().trim().required("Observations field is required"),
        remarksOrActionRequired: Yup.string().trim().required("Remarks/Action field is required"),
        isResponseSharedWithAuthority: Yup.string().required("Response Shared field is required"),
        ncrStatus: Yup.string().required("NCR Status field is required"),
        // dateOfClosure: Yup.date().required("Date Of Closure field is required"),
        // ageingDays: Yup.number().required("Ageing field is required"),
        tatInDays: Yup.number().required("TAT (In Days) field is required"),
        // dateOfResponse: Yup.date().required("Date Of Response field is required"),
        // grilResponse: Yup.string().required("GRIL Response field is required"),
        // numberOfObservationsAddressed: Yup.number().required("Observations Adressed field is required"),
        // responseLetterReference: Yup.string().required("Reference Letter field is required"),
    });

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {

        let reqBody = {
            projectId: projectId,
            dateOfIssuedLetter: moment.utc(values?.dateOfIssuedLetter, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss[Z]'),
            letterNumber: values?.letterNumber,
            numberOfObservationsRaised: values?.numberOfObservationsRaised,
            letterReference: values?.letterReference,
            areaOrItemOfInspection: values?.areaOrItemOfInspection,
            ncRorSO: values?.ncRorSO,
            asset: values?.asset,
            contractorName: values?.contractorName,
            personResponsible: values?.personResponsible,
            // dueDate: moment.utc(values?.dueDate, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss[Z]'),
            observationSummary: values?.observationSummary,
            remarksOrActionRequired: values?.remarksOrActionRequired,
            isResponseSharedWithAuthority: values?.isResponseSharedWithAuthority === 'Yes' ? true : false,
            ncrStatus: values?.ncrStatus,
            dateOfClosure: values?.dateOfClosure
                ? moment.utc(values?.dateOfClosure, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss[Z]')
                : null,
            ageingDays: values?.ageingDays,
            tatInDays: values?.tatInDays,
            dateOfResponse: values?.dateOfResponse
                ? moment.utc(values?.dateOfResponse, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss[Z]')
                : null,
            grilResponse: values?.grilResponse,
            numberOfObservationsAddressed: values?.numberOfObservationsAddressed,
            responseLetterReference: values?.responseLetterReference,
            isActive: true,
        };

        try {
            const response = await createNCRLog({ body: reqBody }).unwrap();
            openNotification("NCR Log created successfully", "success");
            resetForm();
            setSubmitting(false);
            handleClose();
        } catch (error) {
            openNotification(error?.error ?? "Something went wrong", "error");
        } finally {
            setSubmitting(false);
        }
    };

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    return (
        <Dialog open={open}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
            }}>
                <Box>
                    <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                        Add NCR Log
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                <Formik
                    initialValues={formData}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        setFieldTouched,
                        setTouched, }) => (
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2}>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                        Date Of Issued Letter
                                    </Typography>
                                    <TextField
                                        type="date"
                                        name="dateOfIssuedLetter"
                                        value={values.dateOfIssuedLetter}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        onClick={(e) => {
                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                            if (input) input.showPicker?.();
                                        }}
                                        fullWidth
                                        sx={{
                                            ...rightTextStyle,
                                            "& input::-webkit-calendar-picker-indicator": {
                                                display: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& input[type='date']": {
                                                appearance: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    border: "none",
                                                },
                                            },
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                    {CalenderSVG}
                                                </Box>
                                            ),
                                            sx: {
                                                backgroundColor: "#fff",
                                                border: '1px solid',
                                                borderColor: 'hsl(0, 0%, 80%)',
                                                height: "40px",
                                                width: { xs: "100%", md: "100%" },
                                                borderRadius: "5px",
                                            },
                                        }}
                                    />
                                    {touched.dateOfIssuedLetter && errors.dateOfIssuedLetter && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.dateOfIssuedLetter}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>Letter Number</Typography>
                                    <TextField
                                        fullWidth
                                        name="letterNumber"
                                        value={values.letterNumber}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter Letter Number"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    "&:-webkit-autofill": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:hover": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:focus": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                    {touched.letterNumber && errors.letterNumber && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.letterNumber}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>No. Of Observations Raised</Typography>
                                    <TextField
                                        fullWidth
                                        name="numberOfObservationsRaised"
                                        value={values.numberOfObservationsRaised}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter Observations Raised"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    "&:-webkit-autofill": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:hover": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:focus": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                    {touched.numberOfObservationsRaised && errors.numberOfObservationsRaised && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.numberOfObservationsRaised}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>Letter Ref.</Typography>
                                    <TextField
                                        fullWidth
                                        name="letterReference"
                                        value={values.letterReference}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter Letter Ref."
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    "&:-webkit-autofill": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:hover": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:focus": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                    {touched.letterReference && errors.letterReference && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.letterReference}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>Area/Item Of Inspection</Typography>
                                    <TextField
                                        fullWidth
                                        name="areaOrItemOfInspection"
                                        value={values.areaOrItemOfInspection}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter Area/Item Of Inspection"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    "&:-webkit-autofill": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:hover": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:focus": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                    {touched.areaOrItemOfInspection && errors.areaOrItemOfInspection && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.areaOrItemOfInspection}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>NCR/SO</Typography>
                                    <Select
                                        name="ncRorSO"
                                        options={ncrSoOptions}
                                        value={ncrSoOptions.find(opt => opt.value === String(values.ncRorSO)) || null}
                                        onChange={(option) => setFieldValue("ncRorSO", option.value)}
                                        onBlur={() => setFieldTouched("ncRorSO", true)}
                                        placeholder="Select NCR/SO"
                                    />
                                    {touched.ncRorSO && errors.ncRorSO && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.ncRorSO}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 12 }}>
                                    <Typography sx={labelTextStyle}>Asset</Typography>
                                    <TextField
                                        fullWidth
                                        name="asset"
                                        value={values.asset}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter Asset"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    "&:-webkit-autofill": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:hover": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:focus": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                    {touched.asset && errors.asset && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.asset}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 12 }}>
                                    <Typography sx={labelTextStyle}>Observations (summary)</Typography>
                                    <TextField
                                        fullWidth
                                        name="observationSummary"
                                        value={values.observationSummary}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        multiline
                                        rows={3}
                                        placeholder="Enter Observations"
                                        InputProps={{
                                            sx: {
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& textarea::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& textarea": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                },
                                            },
                                        }}
                                    />
                                    {touched.observationSummary && errors.observationSummary && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.observationSummary}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 12 }}>
                                    <Typography sx={labelTextStyle}>Remarks/Action Required</Typography>
                                    <TextField
                                        fullWidth
                                        name="remarksOrActionRequired"
                                        value={values.remarksOrActionRequired}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        multiline
                                        rows={3}
                                        placeholder="Enter Remarks/Action Required"
                                        InputProps={{
                                            sx: {
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& textarea::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& textarea": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                },
                                            },
                                        }}
                                    />
                                    {touched.remarksOrActionRequired && errors.remarksOrActionRequired && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.remarksOrActionRequired}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                        Response Shared With Authority
                                    </Typography>
                                    <Select
                                        name="isResponseSharedWithAuthority"
                                        options={ncrResponse}
                                        value={ncrResponse.find(opt => opt.value === String(values.isResponseSharedWithAuthority)) || null}
                                        onChange={(option) => setFieldValue("isResponseSharedWithAuthority", option.value)}
                                        onBlur={() => setFieldTouched("isResponseSharedWithAuthority", true)}
                                        placeholder="Select Response Shared"
                                    />
                                    {touched.isResponseSharedWithAuthority && errors.isResponseSharedWithAuthority && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.isResponseSharedWithAuthority}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                        NCR Status
                                    </Typography>
                                    <Select
                                        name="ncrStatus"
                                        options={ncrStatusOptions}
                                        value={ncrStatusOptions.find(opt => opt.value === String(values.ncrStatus)) || null}
                                        onChange={(option) => setFieldValue("ncrStatus", option.value)}
                                        onBlur={() => setFieldTouched("ncrStatus", true)}
                                        placeholder="Select NCR Status"
                                    />
                                    {touched.ncrStatus && errors.ncrStatus && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.ncrStatus}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                        Date Of Closure
                                    </Typography>
                                    <TextField
                                        type="date"
                                        name="dateOfClosure"
                                        value={values.dateOfClosure}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        onClick={(e) => {
                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                            if (input) input.showPicker?.();
                                        }}
                                        fullWidth
                                        sx={{
                                            ...rightTextStyle,
                                            "& input::-webkit-calendar-picker-indicator": {
                                                display: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& input[type='date']": {
                                                appearance: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    border: "none",
                                                },
                                            },
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                    {CalenderSVG}
                                                </Box>
                                            ),
                                            sx: {
                                                backgroundColor: "#fff",
                                                border: '1px solid',
                                                borderColor: 'hsl(0, 0%, 80%)',
                                                height: "40px",
                                                width: { xs: "100%", md: "100%" },
                                                borderRadius: "5px",
                                            },
                                        }}
                                    />
                                    {touched.dateOfClosure && errors.dateOfClosure && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.dateOfClosure}
                                        </Typography>
                                    )}
                                </Grid>

                                {/* <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>Ageing</Typography>
                                    <TextField
                                        fullWidth
                                        name="ageingDays"
                                        value={values.ageingDays}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter Ageing"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                },
                                            },
                                        }}
                                    />
                                    {touched.ageingDays && errors.ageingDays && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.ageingDays}
                                        </Typography>
                                    )}
                                </Grid> */}

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>TAT (In Days)</Typography>
                                    <TextField
                                        fullWidth
                                        name="tatInDays"
                                        value={values.tatInDays}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter TAT (In Days)"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    "&:-webkit-autofill": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:hover": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:focus": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                    {touched.tatInDays && errors.tatInDays && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.tatInDays}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                        Date Of Response
                                    </Typography>
                                    <TextField
                                        type="date"
                                        name="dateOfResponse"
                                        value={values.dateOfResponse}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        onClick={(e) => {
                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                            if (input) input.showPicker?.();
                                        }}
                                        fullWidth
                                        sx={{
                                            ...rightTextStyle,
                                            "& input::-webkit-calendar-picker-indicator": {
                                                display: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& input[type='date']": {
                                                appearance: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    border: "none",
                                                },
                                            },
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                    {CalenderSVG}
                                                </Box>
                                            ),
                                            sx: {
                                                backgroundColor: "#fff",
                                                border: '1px solid',
                                                borderColor: 'hsl(0, 0%, 80%)',
                                                height: "40px",
                                                width: { xs: "100%", md: "100%" },
                                                borderRadius: "5px",
                                            },
                                        }}
                                    />
                                    {touched.dateOfResponse && errors.dateOfResponse && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.dateOfResponse}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>Contractor Name</Typography>
                                    <TextField
                                        fullWidth
                                        name="contractorName"
                                        value={values.contractorName}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter Contractor Name"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    "&:-webkit-autofill": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:hover": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:focus": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                    {touched.contractorName && errors.contractorName && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.contractorName}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>Person Responsible</Typography>
                                    <Select
                                        name="personResponsible"
                                        isMulti
                                        options={ncrLogContact}
                                        value={
                                            values.personResponsible
                                                ? values.personResponsible?.split(",").map(v => ncrLogContact?.find(opt => opt?.value === v)).filter(Boolean)
                                                : []
                                        }
                                        onChange={(selectedOptions) => {
                                            const labels = selectedOptions?.map(opt => opt?.value).join(",");
                                            setFieldValue("personResponsible", labels);
                                        }}
                                        onBlur={() => setFieldTouched("personResponsible", true)}
                                        placeholder="Select Person Responsible"
                                    />
                                    {touched.personResponsible && errors.personResponsible && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>
                                            {errors.personResponsible}
                                        </Typography>
                                    )}
                                </Grid>

                                {/* <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                        Due Date
                                    </Typography>
                                    <TextField
                                        type="date"
                                        name="dueDate"
                                        value={values.dueDate}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        onClick={(e) => {
                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                            if (input) input.showPicker?.();
                                        }}
                                        fullWidth
                                        sx={{
                                            ...rightTextStyle,
                                            "& input::-webkit-calendar-picker-indicator": {
                                                display: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& input[type='date']": {
                                                appearance: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    border: "none",
                                                },
                                            },
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                    {CalenderSVG}
                                                </Box>
                                            ),
                                            sx: {
                                                backgroundColor: "#fff",
                                                border: '1px solid',
                                                borderColor: 'hsl(0, 0%, 80%)',
                                                height: "40px",
                                                width: { xs: "100%", md: "100%" },
                                                borderRadius: "5px",
                                            },
                                        }}
                                    />
                                    {touched.dueDate && errors.dueDate && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.dueDate}
                                        </Typography>
                                    )}
                                </Grid> */}

                                <Grid size={{ xs: 12, md: 12 }}>
                                    <Typography sx={labelTextStyle}>GRIL Response</Typography>
                                    <TextField
                                        fullWidth
                                        name="grilResponse"
                                        value={values.grilResponse}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        multiline
                                        rows={3}
                                        placeholder="Enter GRIL Response"
                                        InputProps={{
                                            sx: {
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& textarea::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& textarea": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                },
                                            },
                                        }}
                                    />
                                    {touched.grilResponse && errors.grilResponse && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.grilResponse}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>No. Of Observations Addressed</Typography>
                                    <TextField
                                        fullWidth
                                        name="numberOfObservationsAddressed"
                                        value={values.numberOfObservationsAddressed}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter Observations Addressed"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    "&:-webkit-autofill": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:hover": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:focus": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                    {touched.numberOfObservationsAddressed && errors.numberOfObservationsAddressed && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.numberOfObservationsAddressed}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>Reference Letter</Typography>
                                    <TextField
                                        fullWidth
                                        name="responseLetterReference"
                                        value={values.responseLetterReference}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter Reference Letter"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    "&:-webkit-autofill": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:hover": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:focus": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                    {touched.responseLetterReference && errors.responseLetterReference && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.responseLetterReference}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={12}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Button onClick={handleClose}
                                            sx={{
                                                textTransform: "none",
                                                color: "#F15744",
                                                fontSize: "14px",
                                                lineHeight: "100%",
                                                fontFamily: "Outfit, sans-serif",
                                                borderRadius: "25px",
                                                fontWeight: 500,
                                                px: "20px",
                                                py: "15px",
                                            }}>
                                            Cancel
                                        </Button>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            // loading={isLoading}
                                            sx={{
                                                backgroundColor: "#00344C",
                                                borderRadius: "25px",
                                                textTransform: "none",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                lineHeight: "100%",
                                                fontFamily: "Outfit, sans-serif",
                                                color: "#FFFFFF",
                                                px: "20px",
                                                py: "15px",
                                            }}
                                        >
                                            Save
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </form>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
    );
};

export default AddNCRLog;